import { color, Icon, RadioButton } from '@uniquegood/realworld-studio-design';
import { MarginTop8 } from '@/styles';
import { templateItemRadioButton, TemplateItemStyle, templateItemThumbnail } from './styles';

type EmptyStateTemplateItemProps = Pick<TemplateProject, 'id' | 'name'> & {
  onChange(value?: string): void;
  checked: boolean;
};

export function EmptyStateTemplateItem({
  id,
  name,
  onChange,
  checked
}: EmptyStateTemplateItemProps) {
  return (
    <div css={[TemplateItemStyle]}>
      <div css={[templateItemThumbnail, { backgroundColor: color.background_default }]}>
        <Icon icon="pen_solid" />
      </div>
      <RadioButton
        name="selected-template"
        value={id}
        onChange={onChange}
        checked={checked}
        cssStyle={[MarginTop8, templateItemRadioButton]}
      >
        {name}
      </RadioButton>
    </div>
  );
}
